import {ModalBase} from '../ModalBase'
import {ReactComponent as CloseIcon} from '../../../media/felsv/dark_close_icon.svg'

const ModalConfirmClose = (props: any) => {
  return (
    <ModalBase Styles={props.Styles}>
      <div className='modal-card'>
        <div className='modal-content'>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <h3 className='card-title l'>{props.title}</h3>
            <button style={{backgroundColor: '#FFFFFF'}} onClick={props.closeModal}>
              <CloseIcon width={35} height={35} />
            </button>
          </div>
          <div className='form-separator'></div>
          <p>{props.detail}</p>
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button className='m button transparent w-inline-block' onClick={props.closeModalConfirm}>
              <div>{props.messageClose || 'Cancelar'}</div>
            </button>
            <button className='m button w-inline-block' onClick={props.actionConfirm}>
              <div>{props.messageAction || 'Confirmar'}</div>
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalConfirmClose
